import { observer }                   from 'mobx-react';
import { getDemandTypeIntlLongLabel } from 'constants/DemandTypes';
import { ApiCollection }              from 'collections/ApiCollection';
import DemandTypeModel                from 'models/DemandTypeModel';
import DemandModel                    from 'models/DemandModel';

const DemandType = observer(({ demand, demandTypeCollection }: { demand: DemandModel, demandTypeCollection: ApiCollection<DemandTypeModel> }) => {
  const demandType = demandTypeCollection.findBy('id', demand.get('demandType.id'));

  if (!demandType) {
    return null;
  }

  return <span>{getDemandTypeIntlLongLabel(demandType)}</span>;
});

export default DemandType;
